import React from "react";
import { CircularTestimonials } from "../../../components/ui/circular-testimonials";

const visioneers = [
  {
    quote:
      "I mentor Nesolearn learners moving from theory to production AI systems, helping them build a portfolio institutions and employers actually trust.",
    name: "Sarah Kim",
    designation: "Founder & CEO, Lumen Labs",
    src: "https://cdn.21st.dev/assets/mirror/02/0204be31ac91de05dc9a78ea3438dda481ff3deaaffa40cb28e3bc1822ba3650.jpg",
    socials: {
      github: "https://github.com",
      twitter: "https://twitter.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    quote:
      "Verifiable credentials change how I evaluate talent. On Nesolearn, what a learner shows me is backed by real, on-chain proof of work, not just a claim.",
    name: "Daniel Osei",
    designation: "Principal Engineer, Chainforge",
    src: "https://cdn.21st.dev/assets/mirror/bb/bb5e69602eca31b29b15db66d5f95f5d6e1534037d1cc2c06e8cbb22cafb3a8f.jpg",
    socials: {
      github: "https://github.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    quote:
      "I wrote the book on applied deep learning. Now I help Nesolearn learners turn that theory into shippable, defensible work.",
    name: "Amara Chen",
    designation: "Author, Deep Learning in Practice",
    src: "https://cdn.21st.dev/assets/mirror/b1/b1e3120d49307c1e99ec979e6d05e79f67d7ecea727b27eb716a2b7bff5fe0bb.jpg",
    socials: {
      twitter: "https://twitter.com",
      youtube: "https://youtube.com",
      linkedin: "https://linkedin.com",
    },
  },
  {
    quote:
      "Great products come from people who understand both the craft and the market. That's what I bring to every learner I work with here.",
    name: "Marcus Bello",
    designation: "VP Product, Northbridge Fintech",
    src: "https://cdn.21st.dev/assets/mirror/02/0204be31ac91de05dc9a78ea3438dda481ff3deaaffa40cb28e3bc1822ba3650.jpg",
    socials: {
      linkedin: "https://linkedin.com",
      twitter: "https://twitter.com",
    },
  },
  {
    quote:
      "I built and sold an EdTech company before this. I'm here to help the next generation of builders skip the mistakes I made.",
    name: "Grace Adeyemi",
    designation: "Founder, EdTech Ventures",
    src: "https://cdn.21st.dev/assets/mirror/bb/bb5e69602eca31b29b15db66d5f95f5d6e1534037d1cc2c06e8cbb22cafb3a8f.jpg",
    socials: {
      github: "https://github.com",
      linkedin: "https://linkedin.com",
      youtube: "https://youtube.com",
    },
  },
];

const VisioneerSection = () => (
  <section className="bg-[#060507] py-20 md:py-28 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-14">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tighter text-white mb-4">
          Meet the Visioneers
        </h2>
        <p className="text-lg text-[#a1a1aa] max-w-2xl mx-auto">
          Learn directly from the founders, engineers, and builders shaping how the world learns, verifies, and trusts skill.
        </p>
      </div>

      <CircularTestimonials
        testimonials={visioneers}
        autoplay={true}
        colors={{
          name: "#f7f7ff",
          designation: "#9a9a9a",
          testimony: "#e5e5e5",
          arrowBackground: "#141414",
          arrowForeground: "#f1f1f7",
          arrowHoverBackground: "#0582CA",
        }}
        fontSizes={{ name: "26px", designation: "16px", quote: "17px" }}
      />
    </div>
  </section>
);

export default VisioneerSection;